import {
    Field,
    FormikProps
} from 'formik';
import {
    FormikRadioCardGroup,
    PlatformFieldset
} from "@flexinet/ui-components";
import {
    OrganizationAccountFormType,
    OrganizationAccountStatus
} from "../types.ts";
import {AccountsAutocomplete} from "../../accounts/inputs/AccountsAutocomplete.tsx";


export const FormComponent = (props: FormikProps<OrganizationAccountFormType>) => {

    const editing = typeof props.values.id !== 'undefined';

    return (
        <>
            <PlatformFieldset legend={'Organization Account Details'}>

                <Field
                    name='accountId'
                    label='Account'
                    description='Please select account'
                    component={AccountsAutocomplete}
                    disabled={editing}
                    withAsterisk
                    my={'xl'}
                />

            </PlatformFieldset>


            <PlatformFieldset legend={'Status'}>

                <Field
                    name='organizationAccountStatus'
                    data={[{
                        label: OrganizationAccountStatus.ACTIVE,
                        value: OrganizationAccountStatus.ACTIVE
                    }, {
                        label: OrganizationAccountStatus.INACTIVE,
                        value: OrganizationAccountStatus.INACTIVE
                    }]}
                    component={FormikRadioCardGroup}
                    withAsterisk
                    my={'xl'}
                />

            </PlatformFieldset>
        </>
    );
};
